// Development-only logger. In production builds the calls become no-ops,
// avoiding console noise while preserving useful diagnostics during development.
// Wire any future monitoring (Sentry, Datadog, etc.) here in one place.

const isDev = (typeof process !== "undefined" && process.env && process.env.NODE_ENV !== "production");

export const devLog = {
  log:   (...args) => { if (isDev) console.log(...args); },
  warn:  (...args) => { if (isDev) console.warn(...args); },
  error: (...args) => { if (isDev) console.error(...args); },
  info:  (...args) => { if (isDev) console.info(...args); },
};

export default devLog;
